export const User = {
  SET_FIRST_TIME: 'SET_FIRST_TIME',
  LOG_OUT: 'LOG_OUT',
  UPDATE_USER_INFO: 'UPDATE_USER_INFO',
  UPDATE_USER_INFO_SUCCESS: 'UPDATE_USER_INFO_SUCCESS',
  UPDATE_USER_INFO_FAIL: 'UPDATE_USER_INFO_FAIL',
  UPDATE_MISSING_INFO: 'UPDATE_MISSING_INFO',
  UPDATE_MISSING_INFO_SUCCESS: 'UPDATE_MISSING_INFO_SUCCESS',
  UPDATE_MISSING_INFO_FAIL: 'UPDATE_MISSING_INFO_FAIL',
}



// WEBPACK FOOTER //
// ./src/state/types.js